import { render, staticRenderFns } from "./repair-info.vue?vue&type=template&id=5e71d43f&"
import script from "./repair-info.vue?vue&type=script&lang=js&"
export * from "./repair-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports